import React, { useContext } from 'react';

import NavbarDropdown from './NavbarDropdown';
import NavbarDropdownApp from './NavbarDropdownApp';
import NavbarDropdownPages from './NavbarDropdownPages';
import { AppContext } from '../../../context/AppContext';

const NavbarTopDropDownMenus = () => {
  const {
    config: { navbarCollapsed, showBurgerMenu },
    setConfig
  } = useContext(AppContext);

  const handleDropdownItemClick = () => {
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };
  return (
    <>
      

      <NavbarDropdown title="app">
        <NavbarDropdownApp items={["aa"]} />
      </NavbarDropdown>

      <NavbarDropdown title="pages">
        <NavbarDropdownPages items={["aa"]} />
      </NavbarDropdown>

      
    </>
  );
};

export default NavbarTopDropDownMenus;
